import { render, staticRenderFns } from "./changeProfile.vue?vue&type=template&id=30af08ba&"
import script from "./changeProfile.vue?vue&type=script&lang=js&"
export * from "./changeProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports